import { render, staticRenderFns } from "./TableDataViewModel.vue?vue&type=template&id=72bcfeb8"
import script from "./TableDataViewModel.vue?vue&type=script&lang=js"
export * from "./TableDataViewModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports